// Shopify owns the banner, preference UI and persisted consent.
(() => {
  function synchronizeConsent(forceDenied) {
    let analytics = false;
    let marketing = false;
    try {
      if (forceDenied === true) throw new Error();
      const privacy = window.Shopify.customerPrivacy;
      const choice = privacy.currentVisitorConsent();
      analytics = choice.analytics === 'yes' && privacy.analyticsProcessingAllowed() === true;
      marketing = choice.marketing === 'yes' && privacy.marketingAllowed() === true;
    } catch (_) {
      analytics = false;
      marketing = false;
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    gtag('consent', 'update', {
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied'
    });
  }

  function initializeConsent() {
    if (window.Shopify?.customerPrivacy) {
      synchronizeConsent();
      return;
    }
    if (!window.Shopify?.loadFeatures) {
      synchronizeConsent();
      return;
    }
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
        error => synchronizeConsent(Boolean(error)));
    } catch (_) { synchronizeConsent(true); }
  }

  document.addEventListener('visitorConsentCollected', synchronizeConsent);
  window.addEventListener('pageshow', initializeConsent);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeConsent, { once: true });
  } else {
    initializeConsent();
  }

  // Delegation also supports Shopify section re-rendering. No consent is written.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-native-cookie-preferences]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-native-cookie-status]');
    if (status) status.hidden = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error();
      await window.privacyBanner.showPreferences();
    } catch (_) {
      // Keep the existing button usable for retry; never substitute another modal.
      if (status) status.hidden = false;
    }
  });
})();
